import './Faq.css';
import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import {lang} from '../../common/baseData';
import {decode} from 'html-entities';

function Faq(props) {

  const productsList = (products) => {
    return products.map((product, index) => {
      return (
          <li key={index}>
            {index + 1}.&nbsp;
            <a href={product.URL}>{product['NAME_' + lang.toUpperCase()]}</a>
          </li>
      );
    });
  };

  return (
      <div id="faq-list" className="section accordeon-section">
        <div className="section-title">
          <h2>{props.title}</h2>
        </div>
        {
          props.hasOwnProperty('items') && Array.isArray(props.items)
          && props.items.length ?
              <Accordion allowZeroExpanded={true}
                         allowMultipleExpanded={true}>
                {
                  props.items.map((item, index) => {
                    let question = item.hasOwnProperty('question') &&
                    typeof item.question === 'string' ? item.question : '';
                    let answer = item.hasOwnProperty('answer') &&
                    typeof item.answer === 'string' ? item.answer : '';

                    return <AccordionItem key={index}
                                          activeClassName={'accordeon_item active'}
                                          className={`accordeon_item`}>
                      <AccordionItemHeading className={`accordeon_head`}>
                        <AccordionItemButton>{decode(
                            question)}</AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel className={'accordeon_content'}>
                        <p className="text-content faq-accordeon"
                           dangerouslySetInnerHTML={{__html: answer}}/>
                        {
                          item.hasOwnProperty('products') &&
                          Array.isArray(item.products) && item.products.length ?
                              <ul className={'text-content none-list'}>
                                {productsList(item.products)}
                              </ul> :
                              <></>
                        }
                        {
                          item.hasOwnProperty('cheapProducts') &&
                          Array.isArray(item.cheapProducts) &&
                          item.cheapProducts.length ?
                              <ul className={'text-content none-list'}>
                                {productsList(item.cheapProducts)}
                              </ul> :
                              <></>
                        }
                      </AccordionItemPanel>
                    </AccordionItem>;
                  })
                }
              </Accordion> :
              <></>
        }
      </div>
  );
}

export default Faq;